import React, { useContext, useEffect, useState } from "react";
import CommonModal from "../CommonModal";
import AddPaymentSection from "../../Pages/Admin/Organisation/AddPaymentSection";
import CustomTable from "../../CommonComponents/Table/CustomTable";
import { networkService } from "../../config/axios";
import DeleteOrgModal from "./DeleteOrgModal";
import UserInfoContext from "../../../utils/userInfoContext";
import { AdminActionIcons } from "../../Admin/Shared";
import "../../Admin/Shared/AdminModal.css";

const ManagePayment = ({ openModal, closeModal, companyId }) => {
  const AddPaymentBody = () => {
    const { setShowNotifications } = useContext(UserInfoContext)
    const [show, setShow] = useState('list');
    const [paymentList, setPaymentList] = useState([])
    const [openDelete, setOpenDelete] = useState(false)
    const [paymentData, setPaymentData] = useState({})

    const handleAddPayment = () => {
      setPaymentData({});
      setShow('form');
    };

    useEffect(() => {
      const fetchDomains = async () => {
        const response = await networkService(`admin/company-payments/${companyId}.json`, "GET");
        setPaymentList([...response.data]);
      };
      fetchDomains();
    }, [show, openDelete]);

    const handleDeletePayment = () => {
      const url = `admin/company_payments/${paymentData?.id}.json`;
      networkService(url, "DELETE")
        .then((response) => {
          if (response.status === 204) {
            setOpenDelete(false)
            setShowNotifications({
              showToast: true,
              toastType: "success",
              toastMessage: "Payment deleted",
            })
          }
        })
        .catch((err) => {
          console.error(err);
          setShowNotifications({
            showToast: true,
            toastType: 'danger',
            toastMessage: "Something went wrong"
          })
        });
    }

    const columns = React.useMemo(() => {
      return [
        {
          Header: 'Amount',
          accessor: 'amount',
        },
        {
          Header: 'Currency',
          accessor: 'currency',
        },
        {
          Header: 'Start Date',
          accessor: 'start_date',
        },
        {
          Header: 'End Date',
          accessor: 'end_date',
        },
        {
          Header: 'Created By',
          accessor: 'creator',
        },
        {
          Header: 'Modified By',
          accessor: 'modifier',
        },
        {
          Header: 'Actions',
          accessor: 'action',
          Cell: ({ row }) => (
            <AdminActionIcons
              itemName="Payment"
              onEdit={() => {
                setShow('form');
                setPaymentData(row?.original);
              }}
              onDelete={() => {
                setPaymentData(row?.original);
                setOpenDelete(true);
              }}
            />
          ),
        },

      ];
    }, [paymentList]);

    return (
      <>
        {openDelete &&
          <DeleteOrgModal
            title={'Delete Payment'}
            openModal={openDelete}
            closeModal={setOpenDelete}
            name={'delete Payment'}
            handleDelete={handleDeletePayment}
          />
        }

        {show === 'list' ? (
          <div className="payment-list-view">
            <div className="admin-table-wrapper">
              <CustomTable data={paymentList} columnData={columns} showFilters={false} />
            </div>
            <div className="admin-list-footer">
              <button
                type="button"
                className="admin-cta-button"
                onClick={handleAddPayment}
              >
                + ADD Payment
              </button>
            </div>
          </div>
        ) : (
          <div className="payment-form-view">
            <AddPaymentSection setShow={setShow} companyId={companyId} paymentData={paymentData} />
          </div>
        )}
      </>
    );
  };
  return (
    <CommonModal
      title={"Manage Payments"}
      modalStatus={openModal}
      changeActiveStatus={() => closeModal()}
      classList="admin-modal admin-payment-modal"
      centered
      showFooter={false}
    >
      <AddPaymentBody />
    </CommonModal>
  );
};
export default ManagePayment;
